import { useEffect } from 'react';

import { getSafeElectronAPI } from 'src/hooks/useElectron';
import { useShell } from 'src/legacy/components/Layout/AppShell/ShellContext';

/**
 * Syncs sidebar state between the webapp and the Electron chrome bar.
 * Listens for toggle commands from the chrome bar and reports state changes back.
 */
export const useElectronSidebar = () => {
  const {
    isDesktopSidebarCollapsed,
    toggleDesktopSidebar,
    isResizableSidebarActive,
  } = useShell();

  // Listen for toggle commands from the chrome bar
  useEffect(() => {
    return getSafeElectronAPI().onSidebarToggle(toggleDesktopSidebar);
  }, [toggleDesktopSidebar]);

  // Report sidebar collapsed state to the chrome bar
  useEffect(() => {
    getSafeElectronAPI().reportSidebarState(isDesktopSidebarCollapsed);
  }, [isDesktopSidebarCollapsed]);

  // Report whether the sidebar feature is active
  useEffect(() => {
    getSafeElectronAPI().reportSidebarFeatureActive(isResizableSidebarActive);
  }, [isResizableSidebarActive]);
};
